<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="YSZDtable" :loading="loading" ></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [modalMixins, listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return 'month'
				}
			},
			unit: {
				default: () => {
					return 'month'
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_title: '',
				modal_width: 1200,
				modal_height: 800,
				form: {
					date: [],
					type: null
				},
				list_formConfig: [{
					field: 'date',
					title: '日期',		
					itemRender: {
						defaultValue:this.$Moment().subtract(1, 'day').startOf('day').valueOf(),
						props:{
							type:'date'
						},
						name: '$datePicker'
					}
				},{
					itemRender: {
						name: '$buttons',
						children: [{
							props: {
								type: 'submit',
								content: '查询',
								status: 'primary'
							}
						}, {
							props: {
								type: 'reset',
								content: '重置'
							}
						}]
					}
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width:50,
						fixed:'left',
					},{
						field: 'shopname',
						title: '店铺名称',
						width:100
					},
					{
						title: '支付宝账单',
						children: [
							{
								field: 'zhifubao_inAmount',
								title: '收入金额',
								align: 'center',
								width:100
							},
							{
								field: 'zhifubao_outAmount',
								title: '支出金额',
								align: 'center',
								width:100
							},
						],
						align: 'center'
					},
					{
						title: '微信账单',
						align: 'center',
						children: [
							{
								field: 'weixin_inAmount',
								title: '收入金额',
								align: 'center',
								width:100
							},
							{
								field: 'weixin_outAmount',
								title: '支出金额',
								align: 'center',
								width:100
							},
						]
					},
					{
						title: '保证金账单',
						align: 'center',
						children: [
							{
								field: 'baozhengjin_inoutAmount',
								title: '收支金额',
								align: 'center',
								width:100
							}
						]
					},
					{
						title: '收入类别',
						align: 'center',
						children: [
							{
								field: 'huokuan_inamount',
								title: '货款',
								align: 'center',
								width:100
							},
							{
								field: 'sh_inamount',
								title: '售后金额',
								align: 'center',
								width:100
							},
							{
								field: 'plant_inamount',
								title: '平台费用',
								align: 'center',
								width:100
							}
						]
					},
					{
						field: 'inamount',
						title: '总收入',
						fixed:'right',
						width:100
					},
					{
						title: '支出类别',
						align: 'center',
						children: [
							{
								field: 'tuiguang_outamount',
								title: '推广费用',
								align: 'center',
								width:100
							},
							{
								field: 'yongjin_outamount',
								title: '平台佣金',
								align: 'center',
								width:100
							},
							{
								field: 'yingxiao_outamount',
								title: '营销费用',
								align: 'center',
								width:100
							}
						]
					},
					{
						field: 'outamount',
						title: '总支出',
						fixed:'right',
						width:100
					},
					{
						field: 'task_time',
						title: '日期',
						fixed:'right',
						width:100,
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue,true)
						}
					},
					{
						field: 'update_time',
						title: '最近检测时间',
						width:100,
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue)
						}
					},
					{
						title: '同步万里牛',
						field: 'ordernum',
						align: 'center',
						fixed:'right',
						width:100,
						slots:{
							default:({row})=>{
								if(row.ordernum){
									return <el-popover
												placement="left"
												width="700"
												border
												trigger="hover">
												<el-table data={row.order} size="mini" >
												<el-table-column width="150" property="code" label="单据编码"></el-table-column>
												<el-table-column width="auto" property="payaccName" label="转出账号名称"></el-table-column>
												<el-table-column width="auto" property="amount" label="转出金额"></el-table-column>
												<el-table-column width="auto" property="rcvaccName" label="转入账号名称"></el-table-column>
												<el-table-column width="auto" property="serialType" label="类型"></el-table-column>																							
												<el-table-column width="150" property="export_wln" label="万里牛编码"></el-table-column>
												</el-table>
												<el-link slot="reference" type="primary">{row.uploadordernum}/{row.ordernum}</el-link>												
											</el-popover>
								}
								return null
							}
							
						}
					}
				]
				gridOptions.toolbarConfig.buttons = [{
					name: '重新抓取',
					status: 'danger',
					code: 'grab'
				},{
					name: '生成转账单',
					status: 'primary',
					code: 'createformaltransferaccount'
				},{
					name: '导出',
					status: 'success',
					code: 'export'
				}]
				gridOptions.pagerConfig.enabled = true
			},
			init_formButton() {
				this.list_formButton = []
			},
			createformaltransferaccount(){
				let data =  this.$refs.YSZDtable.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}else{
					this.$confirm('是否确认生成','提示').then(()=>{
						this.loading = true
						data.forEach((item)=>{
							let param = []
							if(parseFloat(item.huokuan_inamount)!=0){
								param.push({
									paycode:item.accountcode,
									type:'货款',
									task_time:item.task_time,
									uniqueid:item.uniqueid,
									amount:parseFloat(item.huokuan_inamount),
									rcvcode:item.rechargeaccountcode,
									mark: '【'+item.accountname+'】转入【'+item.rechargeaccountname+'】，转入金额【'+item.huokuan_inamount+'】，费用项【货款】',
								})
							}
							if(parseFloat(item.sh_inamount)!=0){
								param.push({
									paycode:item.rechargeaccountcode,
									type:'售后金额',
									task_time:item.task_time,
									uniqueid:item.uniqueid,
									amount:parseFloat(item.sh_inamount),
									rcvcode:item.accountcode,
									mark: '【'+item.rechargeaccountname+'】转入【'+item.accountname+'】，转入金额【'+item.sh_inamount+'】，费用项【售后金额】',
								})
							}						
							if(parseFloat(item.plant_inamount)!=0){
								param.push({
									paycode:'1002239',
									type:'平台费用',
									task_time:item.task_time,
									uniqueid:item.uniqueid,
									amount:parseFloat(item.plant_inamount),
									rcvcode:item.accountcode,
									mark: '【平台费用流水】转入【'+item.accountname+'】，转入金额【'+item.plant_inamount+'】，费用项【平台费用】',
								})
							}		
							let amount = parseFloat(item.yongjin_outamount) + parseFloat(item.yingxiao_outamount)
							if(amount!=0){
								param.push({
									paycode:item.rechargeaccountcode,
									type:'平台佣金_营销费用',
									task_time:item.task_time,
									uniqueid:item.uniqueid,
									amount:amount,
									rcvcode:'1002239',
									mark: '【'+item.rechargeaccountname+'】转入【平台费用流水】，转入金额【'+amount+'】，费用项【平台佣金_营销费用】'
								})
							}				
							
							if(parseFloat(item.tuiguang_outamount)!=0){
								param.push({
									paycode:item.rechargeaccountcode,
									type:'推广费用',
									task_time:item.task_time,
									uniqueid:item.uniqueid,
									amount:parseFloat(item.tuiguang_outamount),
									rcvcode:'1002236',
									mark: '【'+item.rechargeaccountname+'】转入【运营推广余额】，转入金额【'+item.tuiguang_outamount+'】，费用项【推广费用】'
								})
							}						
				
							this.$api.formaltransferaccount.createorder({
									data:param
								}).then(() => {	
								this.loading = false
								this.$refs.YSZDtable.commitProxy('query')
								this.$message.success('操作成功')	
							},()=>{
								this.loading = false
							})
						})
					})
				}
			},
			
			
			
			
			
			
			grab(){
				let data =  this.$refs.YSZDtable.getCheckboxRecords()
				if(!data.length){
					let getFormData = this.$refs.YSZDtable.getProxyInfo().form					
					for(let i=0; i<10; i++){
						this.loading = true
						this.$api.downloadstatic.getexcle({			
							code: this.data.code,
							regrab: 1,
							process: i,
							task_time:getFormData.date?getFormData.date/1000:null
						}).then((res) => {	
							if(res.data==1){
								this.loading = false
								this.$refs.YSZDtable.commitProxy('query')
								this.$message.success('操作成功')	
							}						
						})
					}
				}else{
					data.forEach((item)=>{
						this.loading = true
						this.$api.downloadstatic.getexcle({			
							code: this.data.code,
							regrab: 1,
							process: item.process,
							task_time:item.task_time
						}).then((res) => {							
							if(res.data==1){
								this.loading = false
								this.$refs.YSZDtable.commitProxy('query')
								this.$message.success('操作成功')	
							}							
						})
					})	
				}			

			},
			getdata(){
				// let fullData = this.$refs.YSZDtable.getTableData().fullData
				// let getFormData = this.$refs.YSZDtable.getProxyInfo().form
				// if(!getFormData.date){
				// 	this.$message.error('请选择日期')
				// 	return
				// }
				// fullData.forEach((item)=>{
				// 	item.status = ''
				// 	this.loading = true
				// 	let child_key = item.child_key
				// 	this.$api.downloadstatic.getexcle({
				// 		code: this.data.code,
				// 		child_key: child_key,
				// 		date:getFormData.date.join(',')
				// 	}).then((res) => {
				// 		let data = res.data
				// 		let obj = fullData.find((d)=>{
				// 			return d.child_key == child_key
				// 		})
				// 		if(obj){
				// 			//obj.yulibao_initAmount = data.yulibao.initAmount
				// 			obj.yulibao_inAmount = data.yulibao.inAmount
				// 			obj.yulibao_outAmount = data.yulibao.outAmount						
				// 			obj.yulibao_endAmount = data.yulibao.endAmount
							
				// 			obj.zhifubao_initAmount = data.zhifubao.initAmount
				// 			obj.zhifubao_inAmount = data.zhifubao.inAmount
				// 			obj.zhifubao_outAmount = data.zhifubao.outAmount						
				// 			obj.zhifubao_endAmount = data.zhifubao.endAmount
				// 			obj.zhifubao_cash = data.zhifubao.cash
				// 			obj.status = '获取成功'
				// 		}
				// 		//console.log(res)
				// 		this.computeYulibaoendAmount()
				// 		this.loading = false
				// 	},()=>{
				// 		this.loading = false
				// 	})
				// })
			},
			computeYulibaoendAmount(){
				let fullData = this.$refs.YSZDtable.getTableData().fullData
				//console.log(fullData)
				fullData.forEach((item)=>{
					item.yulibao_initAmount = item.yulibao_initAmount ? item.yulibao_initAmount:0
					item.yulibao_endAmount = parseFloat(item.yulibao_initAmount) + parseFloat(item.yulibao_inAmount) + parseFloat(item.yulibao_outAmount)
					item.yulibao_endAmount = item.yulibao_endAmount.toFixed(2)
				})
			},
			list(page) {
				let getFormData = this.$refs.YSZDtable.getProxyInfo().form
				return new Promise((resolve) => {
					this.$api.downloadstatic.getexcle({
						...page,
						code: this.data.code,
						time:getFormData.date?getFormData.date/1000:null
					}).then((res) => {
	
						resolve(res.data)
					})
				})

			},
			modal_init() {
				this.form = {
					date: [],
					type: null
				}
				this.modal_title = this.data.name
				this.modal_model = true
			},
			// modal_show(){

			// 	this.$api.downloadstatic.getexcle({
			// 		code: this.data.code,
			// 	}).then(() => {
			// 		this.$message.success('创建下载任务成功，文件将推送至钉钉')
			// 		this.modal_cancel()
			// 	})
			// },
			submit() {
				if (!this.form.date.length) {
					this.$message.error('请选择统计时间')
					return
				}
				if (!this.form.type) {
					this.$message.error('请选择统计类型')
					return
				}
				this.$api.downloadstatic.getexcletask({
					code: this.data.code,
					type: this.form.type,
					begin: this.form.date[0] / 1000,
					end: this.form.date[1] / 1000,
				}).then(() => {
					this.$message.success('创建下载任务成功，文件将推送至钉钉')
					//this.modal_cancel()
				})
			},
			reset() {

			}
		},
		components: {

		}
	}
</script>